/**
 * created by zhouzt on 2020-05-27
 *
 * description: 枚举相关接口地址
 *
 */

const config = require('libs/config')

const approval = {
	// 协议详情审批
	agreementInfo: config.MS_XY_PATH + '/outline/audit/agreement/detail',
	// 待审批数量
	count: config.MS_ATT_PATH + '/v1/operate/audit/count',
	// 订单详情审批
	orderInfo: config.MS_XY_PATH + '/outline/audit/order/detail'
}

export default approval



// WEBPACK FOOTER //
// ./src/api/approval/index.js